// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__gCJ3t","infoBtn":"quickbooks_infoBtn__kDRo3","formBox":"quickbooks_formBox__JAJWJ","formFooter":"quickbooks_formFooter__3MUIK"};